import script from "./BusinessHandlingStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessHandlingStatistics.vue?vue&type=script&setup=true&lang=js"

import "./BusinessHandlingStatistics.vue?vue&type=style&index=0&id=d5398510&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5398510"]])

export default __exports__